import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: true,
};

const Slider = ({ values }) => {

    const mobileWidth = 668;
    let oldWindowWidth = window.innerWidth;
    const [isMobile, setWindowState] = React.useState({
        isMobile: window.innerWidth <= mobileWidth ? true : false
    })

    React.useEffect(() => {
        function handleResize() {
            if ((oldWindowWidth > mobileWidth && window.innerWidth <= mobileWidth) || (oldWindowWidth < mobileWidth && window.innerWidth >= mobileWidth)) {
                oldWindowWidth = window.innerWidth;
                setWindowState({ isMobile: (window.innerWidth <= mobileWidth ? true : false) })
            }
        }
        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    const linkButton = (value) => {
        if (value.text == null || value.text === undefined || value.text === '') {
            return;
        }
        return <a href={value.url} class="slider__button">{value.text}</a>
    }

    const getMultiLanguageTextColor = (value) => {
        switch (value) {
            case 'Svart':
                return 'Black';
            case 'Vit':
                return 'White';
            default:
                return value;
        }
    }


    return <Carousel {...CarouselSettings}>
        {values.map((value, index) => {
            const textColor = value.textColor === '' ? 'white' : getMultiLanguageTextColor(value.textColor);
            console.log(textColor);
            const hasTint = value.tint == 'True' ? ' tint' : '';
            let image = isMobile.isMobile ? value.mobileImage === '' ? value.image : value.mobileImage : value.image;
            return (
                <a href={value.url} className="slider__link">
                    <img className={`slider__image ${hasTint}`} src={image} />
                    <h1 style={{ 'color': textColor }} className="slider__text">{value.header}</h1>
                    <p style={{ 'color': textColor }} className="slider__subHeader">{value.subHeader}</p>
                    {linkButton(value)}
                </a>
            )

        }
        )}
    </Carousel>
}

export default Slider;